<template>
    <div class="sport-menu-tabs-sec">
        <section class="header-wrapper">
            <div class="header-sec">
                <div class="header-nav">
                    <div class="back-arrow">
                        <a class="chevronLeft-btn" @click="$router.go(-1)"><i class="fa fa-chevron-left"></i></a>
                    </div>
                </div>
            </div>
        </section>
        <section class="walletHistory-wrap pb-3">
            <DepositRequestRejected v-if="walletDetails.status == 2" :walletDetails="walletDetails"    />
            <DepositRequestApproved v-if="walletDetails.status == 1" :walletDetails="walletDetails"  />
            <div class="container">
                <DepositRequestPending v-if="walletDetails.status == 0" :walletDetails="walletDetails"  />
                <TransactionDetail :walletDetails="walletDetails" />        
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { defineAsyncComponent } from 'vue';
import DepositRequestPending from '../components/DepositRequestPending.vue';
import DepositRequestApproved from '../components/DepositRequestApproved.vue';
import DepositRequestRejected from '../components/DepositRequestRejected.vue';
import TransactionDetail from '../components/TransactionDetail.vue';

export default {
    name: "WalletHistoryDetail",
    computed: {
        ...mapGetters(['walletDetails'])
    },
    data(){
        return{
            transactionId: null,
        }
    },
    mounted(){
        this.transactionId = this.$route?.params?.id
    },
    components: { 
        TransactionDetail, 
        DepositRequestRejected, 
        DepositRequestApproved, 
        DepositRequestPending,
    },
};
</script>
